import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import {
    FilterItem,
    FilterItemType,
} from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { KieneBooleanTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { FibuHonorarTa } from './fibu-honorar-ta';
import { FibuHonorarTaDialogComponent } from './fibu-honorar-ta-dialog/fibu-honorar-ta-dialog.component';

@Component({
    selector: 'kiene-honorar-tieraerzte',
    templateUrl: './honorar-tieraerzte.component.html',
    styleUrls: ['./honorar-tieraerzte.component.scss'],
})
export class HonorarTieraerzteComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        private dialog: MatDialog,
        private api: KieneTableService,
        private messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        this.tableDescriptor.headline = 'Honorar-TAs';
        this.tableDescriptor.uniqueIdentifier = 'FibuHonorarTieraerzte';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'fibu_honorar_ta/';
        this.tableDescriptor.route = '/finanzen/kontenrahmen/honorar-tieraerzte/';
        this.tableDescriptor.nameOfIdField = 'fibu_honorar_ta_id';
        this.tableDescriptor.searchPlaceholder = 'Name, Suffix oder Tierarzt suchen';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.addVoid = this.openDialog.bind(this);
        this.tableDescriptor.showDetails = false;
        this.tableDescriptor.showDetailsVoid = this.openDialog.bind(this);
        this.tableDescriptor.permissionView = 17010;
        this.tableDescriptor.permissionCreate = 17011;
        this.tableDescriptor.initialSortColumn = 'kostenstelle_suffix';
        this.tableDescriptor.initialSortDirection = 'asc';

        this.tableDescriptor.columns = [
            new TableColumn('kostenstelle_suffix', 'Haupt-Suffix'),
            new TableColumn('bezeichnung', 'Bezeichnung'),
            new TableColumn('kostenarten_map', 'Suffixe je Kostenart'),
            new TableColumn('tierarzt', 'Tierarzt'),
            new KieneBooleanTableColumn('aktiv', 'Aktiv'),
        ];

        this.tableDescriptor.options.push(
            new TableOption(this.openDialog.bind(this), 'Editieren', 'edit', 17011),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.confirmAndDelete.bind(this), 'Löschen', 'delete', 17012),
        );

        this.tableDescriptor.filterItems.push(
            new FilterItem('Aktiv', '1', FilterItemType.CHECKBOX, 'aktiv', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Inaktiv', '0', FilterItemType.CHECKBOX, 'aktiv', false),
        );
    }

    openDialog(row?: FibuHonorarTa) {
        const dialogRef = this.dialog.open(FibuHonorarTaDialogComponent, {
            width: '720px',
            maxHeight: '90vh',
            data: { honorarTa: row ? { ...row } : null },
        });
        dialogRef.afterClosed().subscribe(saved => {
            if (saved) {
                this.api.reload();
            }
        });
    }

    confirmAndDelete(row: FibuHonorarTa) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            data: {
                title: 'Honorar-TA löschen',
                text: `${row.bezeichnung || 'Eintrag'} wirklich löschen?`,
            },
        });
        dialogRef.afterClosed().subscribe(ok => {
            if (!ok) {
                return;
            }
            this.api.deleteEntity(this.apiBaseUrl + 'fibu_honorar_ta/delete.php', row).subscribe({
                next: () => {
                    this.messageService.infoMessage('Honorar-TA gelöscht.');
                    this.api.reload();
                },
                error: err => {
                    this.messageService.errorMessage('Honorar-TA konnte nicht gelöscht werden.', err);
                    this.api.reload();
                },
            });
        });
    }
}
